import React from 'react';
import TableChatSection from './TableChatSection';
import { Helmet } from 'react-helmet-async';

const TableChatHeroSection = () => {
  // Structured data for better SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Strive Data Analysis Platform",
    "description": "AI-powered customer feedback analysis and prioritization platform",
    "image": "https://strive.us/og-image.png",
    "video": {
      "@type": "VideoObject",
      "name": "Strive Platform Overview",
      "description": "Overview of Strive's AI-powered product operations platform",
      "thumbnailUrl": "https://customer-f5xkmr6krvr9p6pu.cloudflarestream.com/b922fd8fd0f091d8f616969e79def195/thumbnails/thumbnail.jpg",
      "uploadDate": "2025-03-16T00:00:00Z",
      "duration": "PT1M09S",
      "contentUrl": "https://customer-f5xkmr6krvr9p6pu.cloudflarestream.com/b922fd8fd0f091d8f616969e79def195/iframe"
    },
    "brand": {
      "@type": "Brand",
      "name": "Strive"
    },
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/OnlineOnly",
      "price": "499",
      "priceCurrency": "USD",
      "priceSpecification": {
        "@type": "PriceSpecification",
        "price": "499",
        "priceCurrency": "USD"
      }
    },
    "hasMerchantReturnPolicy": {
      "@type": "MerchantReturnPolicy",
      "applicableCountry": "US",
      "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
      "merchantReturnDays": "30",
      "returnMethod": "https://schema.org/ReturnByMail",
      "returnFees": "https://schema.org/FreeReturn"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "150"
    },
    "review": {
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "author": {
        "@type": "Person",
        "name": "James P.",
        "jobTitle": "Product Strategy Lead"
      },
      "reviewBody": "Strive spots patterns in customer feedback that we would never have found manually.",
      "itemReviewed": {
        "@type": "Product",
        "name": "Strive Product Operations & Revenue Intelligence",
        "offers": {
          "@type": "Offer",
          "availability": "https://schema.org/OnlineOnly",
          "price": "499",
          "priceCurrency": "USD",
          "priceSpecification": {
            "@type": "PriceSpecification",
            "price": "499",
            "priceCurrency": "USD"
          }
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "150"
        }
      }
    },
    "featureList": [
      "Table-based data analysis",
      "Document processing",
      "AI-powered chat interface",
      "Seamless data transformation",
      "Interactive data visualization"
    ]
  };

  return (
    <>
      <Helmet>
        <title>Data Analysis Without Limitations | Strive</title>
        <meta name="description" content="Analyze your data without limitations. Work with tables, documents, and use AI-powered chat to transform information from one form to another—all in one seamless platform." />
        <meta name="keywords" content="data analysis, AI chat, data transformation, table analysis, document processing, data visualization, business intelligence" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <section 
        id="chat-with-data" 
        className="py-8 bg-white"
        aria-labelledby="data-analysis-title"
      >
        <div className="container mx-auto px-4">
          {/* Header and Subheader */}
          <header className="mb-8 text-center">
            <h2 
              id="data-analysis-title"
              className="text-4xl md:text-5xl font-bold mb-6 text-gray-900 mx-auto max-w-3xl"
            >
              Show up with proof, not opinions. Be undeniably valuable.
            </h2>
            <p className="text-lg md:text-xl text-gray-600 mx-auto max-w-3xl mb-6">
              Strive helps you work like a data scientist - without being one. Merge CSVs, extract insights from documents, and use AI-powered workflows to surface what matters, fast.
            </p>
          </header>

          {/* Table Chat Section */}
          <div className="relative">
            <div 
              className="h-[650px] rounded-[8px]"
              role="region"
              aria-label="Interactive data analysis interface"
            >
              <TableChatSection showHeader={false} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TableChatHeroSection; 